export default __webpack_public_path__ + "static/media/share.d8b689c8.svg";